import React from "react";

export default function StarRating({ value = 0, size = 16, showValue = false }) {
  const rating = Math.max(0, Math.min(5, Number(value) || 0));

  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <div style={{ position: "relative", display: "inline-block" }}>
        <div style={{ color: "#d1d5db", fontSize: size }}>
          ★★★★★
        </div>

        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            overflow: "hidden",
            width: `${(rating / 5) * 100}%`,
            color: "#f59e0b",
            fontSize: size,
          }}
        >
          ★★★★★
        </div>
      </div>

      {showValue && (
        <span style={{ fontSize: 14, color: "#6b7280" }}>
          {rating.toFixed(1)}
        </span>
      )}
    </div>
  );
}